/**
 * The Vantage shield-with-V mark. Same artwork as public/vantage.svg (favicon) and the email logo PNG.
 */

const SHIELD = 'M32 3 55 11.5v18.3c0 14.6-9.6 26.4-23 31.2C18.6 56.2 9 44.4 9 29.8V11.5z';

export default function BrandMark({ className = 'h-12 w-12', label }: { className?: string; label?: string }) {
  return (
    <svg data-testid="brand-mark" className={className} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg"
      role={label ? 'img' : undefined} aria-label={label} aria-hidden={label ? undefined : true}>
      <path d={SHIELD} fill="#4f46e5" />
      <path d={SHIELD} fill="none" stroke="#a5b4fc" strokeWidth="2" strokeLinejoin="round" />
      <path d="M19.5 20h7.4L32 36.6 37.1 20h7.4L35.6 45h-7.2z" fill="#fff" />
    </svg>
  );
}
